import { useEffect, useState, useCallback } from "react";
import ButtonIconH from "./ButtonIconH";
import TooltipBox from "./Tooltip";
import "../css/ProductImg.css";

export default function ProductImg(props) {
  const [productImage, setProductImage] = useState(null);

  const handleFileInputChange = useCallback(
    (e) => {
      const file = e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (event) => {
          const base64String = event.target.result;
          setProductImage(base64String);
          props.onUpload(base64String, file.name);
        };
        reader.readAsDataURL(file);
      }
    },
    [props],
  );

  const handleDragEvents = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  const handleDrop = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();

      const file = e.dataTransfer.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (event) => {
          const base64String = event.target.result;
          setProductImage(base64String);
          props.onUpload(base64String, file.name);
        };
        reader.readAsDataURL(file);
      }
    },
    [props],
  );

  useEffect(() => {
    setProductImage(props.img);
  }, [props.img]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: "20px",
      }}
    >
      <div
        className="product-img-container"
        onDragOver={handleDragEvents}
        onDragEnter={handleDragEvents}
        onDragLeave={handleDragEvents}
        onDrop={handleDrop}
      >
        <img className="pic" src={productImage}></img>
        {!productImage && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              flex: 1,
            }}
          >
            <input
              id="file-input"
              className="hidden"
              type="file"
              accept="image/*"
              value={""}
              onChange={handleFileInputChange}
            ></input>
            <div
              style={{
                display: "flex",
                height: "100%",
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <label htmlFor="file-input">
                <img
                  id="file-input"
                  src="/images/new-blue.svg"
                  loading="lazy"
                  alt="Icon"
                  data-tooltip-id="ttimg"
                  className="icon"
                  onClick={() => {}}
                />
                <TooltipBox
                  id="ttimg"
                  content={
                    <div className="opt-table-tooltip grid-5">
                      <div className="cell combined-cells-5 cell-start-content">
                        Nueva imagen
                      </div>
                    </div>
                  }
                ></TooltipBox>
              </label>
              <span style={{ fontSize: "12px", fontStyle: "italic" }}>
                Haga clic o arrastre aquí la imagen
              </span>
            </div>
          </div>
        )}
        {productImage && (
          <ButtonIconH
            text="Eliminar"
            small={true}
            onClick={async () => {
              props.onDelete();
            }}
          ></ButtonIconH>
        )}
      </div>
    </div>
  );
}
